import { useContext, useEffect, useRef, useState } from "react";
import { QuantityStripper } from "../../../../Layout/Common/quantityStripper";
import { useGlobalFunction } from "../../../../Context/GlobalFunctionContext";
import { GlobalContext } from "../../../../Context/GlobalContext";
import { ConvertToFloat } from "../../../../Layout/Common/common";
import { ImageWithDefault } from "../../../../Layout/Common/imageWithDefault";
import { WishlistItem } from "../../../../Layout/Common/addWhistList";
import Skeleton from "react-loading-skeleton";
import { ItemReferenceInput } from "../../../../Layout/Common/itemReferenceInput";

export const OrderItemRow = ({ row, index }) => {
  const [item, setItem] = useState();
  const { CartItem } = useContext(GlobalContext);
  const { getProductPrice, getStockStatus, handleAddtoCart } = useGlobalFunction();
  const [productStock, setProductStock] = useState(null);
  const [productPrice, setProductPrice] = useState(null);
  const [isAdded, setIsadded] = useState(false);
  const [qty, setQty] = useState({});
  const prevState = useRef();
  useEffect(() => {
    if (row && (prevState.current == undefined || prevState.current.prod_id != row.prod_id)) {
      setItem(row);
      prevState.current = row;
      setQty({ prod_id: row.prod_id, qty: 0 });
      fetchStockStatus(row.prod_id);
      fetchProductPrice(row.prod_id);
    }
  }, [row]);

  useEffect(() => {
    if (row && CartItem && CartItem.cartItem && CartItem.cartItem.length > 0) {
      var products = CartItem.cartItem;
      var filterProductId = products.find((it) => parseInt(it.prod_id) == parseInt(row.prod_id));
      setIsadded(!!filterProductId);
      setQty({
        prod_id: row.prod_id,
        qty: filterProductId && filterProductId.qty ? filterProductId.qty : 0,
      });
    } else {
      setQty({
        prod_id: row.prod_id,
        qty: 0,
      });
    }
  }, [CartItem, CartItem.cartItem, row]);

  const fetchStockStatus = async (productId) => {
    let response = await getStockStatus(productId);
    if (response) {
      setProductStock(response);
    }
  };
  const fetchProductPrice = async (productId) => {
    let price = await getProductPrice(productId ?? 0);
    if (price) setProductPrice(ConvertToFloat(price));
  };

  return (
    <div className="col-lg-12 order-history-item" key={index}>
      {item && (
        <div className="myAccount-orderItem">
          <div className="myAccount-orderItem-lft">
            <div className="myAccount-orderItem-img">
              <ImageWithDefault src={item.image_th} alt={item.description} />
            </div>
            <div className="myAccount-orderItem-details">
              <h3>{item.description}</h3>
              <div className="orderItem-features">
                <ul>
                  <li>
                    <span>Qty:</span>
                    <span>{item.qty}</span>
                  </li>
                  <li>
                    <span>Code:</span>
                    <span>{item.prod_code}</span>
                  </li>
                  <li>${productPrice ? ConvertToFloat(productPrice) : item.total_ext} each</li>
                  <li className="orderItem-features-price">${ConvertToFloat(item.total_ext)}</li>
                </ul>
              </div>
              <ItemReferenceInput item={item} readOnly />
            </div>
          </div>
          <div className="myAccount-orderItem-rht">
            <div className="cart-remove-wishlist orderItem-wishlist">
              <WishlistItem productId={item.prod_id} />
            </div>
            {productStock ? (
              productStock.isShowBuy && qty ? (
                <div className="myAccount-orderItem-details">
                  <QuantityStripper
                    prd={qty}
                    className="mt-0"
                    inline={false}
                    params={{
                      code: item.prod_code,
                      desc: item.description,
                      img: item.image_th,
                    }}
                  />
                </div>
              ) : (
                <div className="product-quantity mt-2">
                  <Skeleton width={150} height={32} />
                </div>
              )
            ) : (
              <Skeleton width={120} height={40} />
            )}
          </div>
        </div>
      )}
    </div>
  );
};
